import request from './request.js';
import {requestbody} from './request.js'
import requestAuth from './request.js';

export async function getHuizjigou(params = {

}) {
    return await requestbody('/sys/getHuizjigou', 'post', params)
}

export async function saveorganization(params = {

}) {
    return await requestbody('/sys/new/company', 'post', params)
}

export async function getShuijQiyInfo(params = {

}) {
    return await request('/sys/getShuijQiyInfo', 'post', params)
}

export async function saveNode(params = {

}) {
    return await requestbody('/system/dept/save', 'post', params)
}

//多级菜单获取
export async function groupList(params = {

}) {
    return await requestbody('/system/dept/getDeptTreeTableList', 'get', params)
}


// 城市下拉选框接口

export async function getDqSelect(params = {

}) {
    return await requestbody('/sys/getDqSelect', 'post', params)
}


// 身份类型下拉选框接口
export async function getByDqSflx(params = {

}) {
    return await request('/sys/getByDqSflx', 'post', params)
}


// 动态获取表格
export async function getByDqform(params = {

}) {
    return await request('/sys/getByDqForm', 'post', params)
}


// 登录方式下拉选框接口
export async function logins(params = {

}) {
    return await request('/sys/getDqDenglfs', 'post', params)
}

//删除
export async function deles(params = {

}) {
    return await request('/system/dept/delete', 'post', params)
}

//公司修改
export async function updates(params = {

}) {
    return await requestbody('/system/dept/update', 'post', params)
}

//查询节点下所有公司信息
export async function queryNode(params = {

}) {
    return await requestbody('/sys/condition/query', 'post', params)
}


//根据公司id查询公司申报内容信息
export async function shenBContent(params = {

}) {
    return await request('/sys/query/company/shenBContent', 'post', params)
}

//根据公司id查询公司基础信息	
export async function company(params = {

}) {
    return await request('/sys/query/company', 'post', params)
}

// 获取登记注册类型
export async function LoginRegisterType(params = {

}) {
    return await request('/sys/getLoginRegisterType', 'post', params)
}

//根据公司id查询公司报税登录信息
export async function loginInfo(params = {

}) {
    return await request('/sys/query/company/loginInfo', 'post', params)
}
//获取所属行业
export async function SshyTree(params = {

}) {
    return await request('/sys/getSshyTree', 'post', params)
}
//基础信息编辑
export async function information(params = {

}) {
    return await requestbody('/sys/edit/company', 'post', params)
}
// 查询网关信息
export async function queryGatewayInfo(params = {

}) {
    return await request('/sys/queryGatewayInfo', 'post', params, false)
}
export async function companyLoginInfo(params = {

}) {
    return await requestbody('/sys/edit/company/LoginInfo', 'post', params)
}
export async function zzs(params = {

}) {
    return await requestbody('/sys/tax/edit/zzs', 'post', params)
}

export async function editzzs(params = {

}) {
    return await requestbody('/sys/edit/zzs', 'post', params)
}

export async function editqysds(params = {

}) {
    return await requestbody('/sys/tax/edit/qysds', 'post', params)
}
export async function taxeditqysds(params = {

}) {
    return await requestbody('/sys/edit/qysds', 'post', params)
}
export async function cwbb(params = {

}) {
    return await requestbody('/sys/tax/edit/cwbb', 'post', params)
}

export async function editcwbb(params = {

}) {
    return await requestbody('/sys/edit/cwbb', 'post', params)
}

export async function taxyhs(params = {

}) {
    return await requestbody('/sys/tax/edit/yhs', 'post', params)
}
export async function sysYhsSm(params = {

}) {
    return await requestbody('/sys/getYhsSm', 'post', params)
}


export async function edityhs(params = {

}) {
    return await requestbody('/sys/edit/yhs', 'post', params)
}

export async function fccztd(params = {

}) {
    return await requestbody('/sys/tax/edit/fccztd', 'post', params)
}

export async function editfccztds(params = {

}) {
    return await requestbody('/sys/edit/fccztds', 'post', params)
}
export async function hjbhs(params = {

}) {
    return await requestbody('/sys/tax/edit/hjbhs', 'post', params)
}
export async function edithbs(params = {

}) {
    return await requestbody('/sys/edit/hbs', 'post', params)
}

export async function shenbaoContent(params = {

}) {
    return await requestbody('/sys/edit/company/shenbaoContent', 'post', params)
}

export async function queryCcxwsPolicy(params = {

}) {
    return await request('/sys/queryCcxwsPolicy', 'post', params)
}

export async function editCcxwsPolicy(params = {

}) {
    return await requestbody('/sys/editCcxwsPolicy', 'post', params)
}

export async function taxeditzzs(params = {

}) {
    return await requestbody('/sys/tax/edit/zzs', 'post', params)
}

export async function login(params = {

}) {
    return await requestbody('/login', 'post', params)
}
//文化事业建设废
export async function querywhsy(params = {

}) {
    return await requestbody('/sys/tax/edit/whsy', 'post', params)
}

export async function preservationwhsy(params = {

}) {
    return await requestbody('/sys/edit/whsy', 'post', params)
}

//通用申报
export async function queryty(params = {

}) {
    return await requestbody('/sys/tax/edit/ty', 'post', params)
}
export async function preservationty(params = {

}) {
    return await requestbody('/sys/edit/ty', 'post', params)
}
//残障金保存接口
export async function editcbj(params = {

}) {
    return await requestbody('/sys/edit/cbj', 'post', params)
}

//申报辅助弹窗配置
export async function queryDiaLogInfo(params = {

}) {
    return await request('/manuscript/extend/queryDiaLogInfo', 'post', params)
}
export async function saveDiaLogInfo(params = {

}) {
    return await requestbody('/manuscript/extend/saveDiaLogInfo ', 'post', params)
}

export async function startTaxGather(params = {

}) {
    return await request('/sys/start/taxGather', 'post', params)
}
export async function get_info(params = {
}) {
    return await requestbody('/xfs_xfp_info/get_info', 'post', params)
}
export async function save_info(params = {
}) {
    return await requestbody('/xfs_xfp_info/save_info', 'post', params)
}

export async function tripartite_agreement_query(params = {
}) {
    return await request('/tripartite-agreement/page', 'post', params)
}

export async function tripartite_agreement_delete(params = {
}) {
    return await request('/tripartite-agreement/delete', 'post', params)
}

export async function tripartite_agreement_save(params = {
}) {
    return await requestbody('/tripartite-agreement/save', 'post', params)
}


export async function tripartite_agreement_update(params = {
}) {
    return await requestbody('/tripartite-agreement/update', 'post', params)
}

export async function query_login_status(params = {
}) {
    return await request('/sys/queryRPALoginStatus', 'post', params)
}

export async function send_sms(params = {
}) {
    return await request('/sys/sendSms', 'post', params)
}

export async function submit_sms(params = {
}) {
    return await request('/sys/submitSms', 'post', params)
}

export async function downloadPdf(params = {
}) {
    return await request('/batch/pdfDownLoad', 'post', params)
}

export async function queryBatchLog(params = {
}) {
    return await request('/batch/queryBatchLog', 'post', params)
}
export async function deleteBatchAutoLog(params = {
}) {
    return await request('/batch/deleteBatchAutoLog', 'post', params)
}
export async function updateBatchAutoLog(params = {
}) {
    return await request('/batch/updateBatchAutoLog', 'post', params)
}